import { apiFetch } from "./client";

const fetchCustomers = async ({ includeArchived = true } = {}) =>
  apiFetch(`/api/customers${includeArchived ? "?includeArchived=1" : ""}`);

const toCleanString = (value) => {
  if (value === undefined || value === null) return "";
  return `${value}`.trim();
};

const normalizeContact = (payload = {}) => {
  const contact = payload.contact || {};
  const phone = toCleanString(payload.phone ?? contact.phone);
  const email = toCleanString(payload.email ?? contact.email);

  const result = {};
  if (phone) result.phone = phone;
  if (email) result.email = email;
  return result;
};

const createCustomer = async (payload = {}) => {
  const name = payload?.name?.trim();
  if (!name) {
    throw new Error("Customer name is required");
  }

  const address = payload?.address?.trim();
  const notes = payload?.notes?.trim();
  const contact = normalizeContact(payload);

  const body = {
    name,
    ...(address ? { address } : {}),
    ...(notes ? { notes } : {}),
    ...(Object.keys(contact).length ? { contact } : {}),
  };

  return apiFetch("/api/customers", {
    method: "POST",
    body: JSON.stringify(body),
  });
};

const updateCustomer = async (id, payload = {}) => {
  const normalizedId = toCleanString(id);
  if (!normalizedId) {
    throw new Error("Customer id is required");
  }

  const address = payload?.address?.trim();
  const notes = payload?.notes?.trim();
  const contact = normalizeContact(payload);
  const body = {
    ...(payload?.name ? { name: payload.name.trim() } : {}),
    ...(address ? { address } : {}),
    ...(notes ? { notes } : {}),
    ...(Object.keys(contact).length ? { contact } : {}),
  };

  return apiFetch(`/api/customers/${normalizedId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
};

const archiveCustomer = async (id) => {
  const normalizedId = toCleanString(id);
  if (!normalizedId) {
    throw new Error("Customer id is required");
  }
  return apiFetch(`/api/customers/${normalizedId}/archive`, { method: "PATCH" });
};

const restoreCustomer = async (id) => {
  const normalizedId = toCleanString(id);
  if (!normalizedId) {
    throw new Error("Customer id is required");
  }
  return apiFetch(`/api/customers/${normalizedId}/restore`, { method: "PATCH" });
};

export { fetchCustomers, createCustomer, updateCustomer, archiveCustomer, restoreCustomer };
